import React from 'react'
import { useTranslation } from 'react-i18next'
import IconCalendar from '../../assets/icons/calendar.svg?react'
import { MarketBars } from './MarketBars'

type PortfolioCardProps = {
    label: string
    value: string
    widthPct: number
    color: string
    note: string
    insufficientSample: boolean
    markets: Array<{ code: string; widthPct: number; value: string }>
}

export const PortfolioCard: React.FC<PortfolioCardProps> = ({
    label, value, widthPct, color, note, insufficientSample, markets
}) => {
    const { t } = useTranslation('dashboard')
    return (
    <div className="bg-white rounded-2xl p-4 border border-neutralBlack-200 shadow-sm flex flex-col gap-2.5">
        <div className="flex items-center gap-2 flex-wrap">
            <span className="flex-1 min-w-0 text-[11.5px] font-medium tracking-wide uppercase text-neutralBlack-500">{label}</span>
            <span className="inline-flex items-center gap-1.5 border border-neutralBlack-200 rounded-full bg-neutralBlack-50 px-2.5 h-7 text-xs text-neutralBlack-600 whitespace-nowrap">
                <IconCalendar className="w-3 h-3 text-neutralBlack-500" />
                {t('metrics.portfolioAllTime')}
            </span>
        </div>
        <div className="flex items-baseline gap-2">
            <span className={`text-[26px] font-semibold tracking-tight ${insufficientSample ? 'text-neutralBlack-400' : 'text-neutralBlack-900'}`}>
                {value}
            </span>
        </div>
        {!insufficientSample && (
            <span className="h-[5px] rounded-full bg-neutralBlack-100 overflow-hidden">
                <span className="block h-[5px] rounded-full" style={{ width: `${widthPct}%`, background: color }} />
            </span>
        )}
        <span className="text-[12.5px] leading-relaxed text-neutralBlack-600">{note}</span>
        {markets.length > 0 && <MarketBars items={markets} barColor={color} />}
    </div>
    )
}
